// This is a temporary list of vendor extensions as workaround to not being able to put appIds into Statsig feature flags
export var privateAppExtensionList = {
  '57f0f0f6-c4bd-46df-93b1-a090332de70a': {
    app_name: 'nexus-components',
    site_name: 'MSCI',
    marketplace_type: 'Private',
    appid: '57f0f0f6-c4bd-46df-93b1-a090332de70a'
  },
  'cd3b7a85-32e7-4910-8fb4-e1604ff35b95': {
    app_name: 'nexus-systems',
    site_name: 'MSCI',
    marketplace_type: 'Private',
    appid: 'cd3b7a85-32e7-4910-8fb4-e1604ff35b95'
  },
  '725684c4-3375-4431-818f-7697fb1ec3c5': {
    site_name: 'billcom',
    marketplace_type: 'Private',
    appid: '725684c4-3375-4431-818f-7697fb1ec3c5'
  },
  '411935c8-e985-43e1-a91c-df4a1399f3a1': {
    app_name: 'jira-assets-client-sync',
    site_name: 'Interactio.io',
    marketplace_type: 'Private',
    appid: '411935c8-e985-43e1-a91c-df4a1399f3a1'
  },
  '0e0dfd8-0e8e-4b92-9700-bfd00ec77ca8': {
    app_name: 'slack-send-v2',
    site_name: 'Interactio.io',
    marketplace_type: 'Private',
    appid: '40e0dfd8-0e8e-4b92-9700-bfd00ec77ca8'
  },
  '27e1630b-7796-4c1c-8431-d3dacd0b0a65': {
    site_name: 'FusionSpan',
    marketplace_type: 'Private',
    appid: '27e1630b-7796-4c1c-8431-d3dacd0b0a65'
  },
  'cf02163e-b400-4e6e-902b-049492d4675c': {
    site_name: 'dalet',
    marketplace_type: 'Private',
    appid: 'cf02163e-b400-4e6e-902b-049492d4675c'
  }
};